module.exports = __webpack_public_path__ + "static/media/silkeHeinz.f80da7f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/silkeHeinz.jpg
// module id = 1281
// module chunks = 1